import { render } from "./Judging.vue?vue&type=template&id=3c6d452c"
import script from "./Judging.vue?vue&type=script&lang=js"
export * from "./Judging.vue?vue&type=script&lang=js"

import exportComponent from "C:\\souvenirbrandsaward\\souvenirbrandsaward\\souvenirbrandsaward_FE\\souvenirbrandsaward_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__